import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=eff4f3c0&scoped=true&"
import script from "./Spotlight.vue?vue&type=script&lang=ts&"
export * from "./Spotlight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff4f3c0",
  null
  
)

export default component.exports